import EVENT from '../enums/event.js';
import debounce from '../utils/debounce.js';
import dispatchEvent from '../utils/dispatch-event.js';

const selectors = {
  searchIcon: '[data-search-mobile]',
  searchForm: '[data-search-form]',
};

class StickyHeader {
  constructor(shopifyHeader) {
    this.shopifyHeader = shopifyHeader;
    this.marquee = document.querySelector('#shopify-section-top-banner');
    this.currentScrollPos = window.pageYOffset;
    this.prevScrollpos = window.pageYOffset;
    this.searchForm = document.querySelector(selectors.searchForm);
    this.searchIcon = document.querySelector(selectors.searchIcon);

    this.debouncedScrollHandler = debounce(() => this.scrollHandler(), 100);
    // for mobile touch
    window.addEventListener('touchmove', this.debouncedScrollHandler);
    window.addEventListener('scroll', this.debouncedScrollHandler);

    document.addEventListener(EVENT.FILTERS.FILTER_LIST_OPENED, () => {
      this.hideHeader();
    });
    this.searchIconEventListener();

    this.shopifyHeader.dataset.header = 'true';
    this.shopifyHeader.dataset.searchBarVisible = 'true';
  }

  showHeader() {
    this.shopifyHeader.style.top = '0';
    dispatchEvent(EVENT.HEADER.VISIBLE, document);
  }

  shouldShowHeader() {
    return (
      this.prevScrollpos > this.currentScrollPos && this.currentScrollPos !== 0
    );
  }

  shouldShowSearchIcon() {
    return this.currentScrollPos > 50;
  }

  hideHeader() {
    this.shopifyHeader.style.top = `-${this.shopifyHeader.offsetHeight}px`;
    dispatchEvent(EVENT.HEADER.HIDDEN, document);
  }

  showSearchIcon() {
    if (this.searchIcon.classList.contains('opacity-0')) {
      this.searchIcon.classList.remove('opacity-0', 'pointer-events-none');
      this.hideSearchBar();
    }
  }

  hideSearchBar() {
    this.searchForm.classList.add('!h-0');
    this.searchForm.classList.add('translate-y-[-100%]');
    document.querySelector('main').classList.remove('headerSpacing');
    this.shopifyHeader.dataset.searchBarVisible = 'false';
  }

  toggleSearchBar() {
    const main = document.querySelector('main');
    if (this.searchForm.classList.contains('translate-y-[-100%]')) {
      this.searchForm.classList.remove('!h-0');
      this.searchForm.classList.remove('translate-y-[-100%]');
      main.classList.add('headerSpacing');
      this.shopifyHeader.dataset.searchBarVisible = 'true';
    } else {
      this.searchForm.classList.add('!h-0');
      this.searchForm.classList.add('translate-y-[-100%]');
      main.classList.remove('headerSpacing');
      this.shopifyHeader.dataset.searchBarVisible = 'false';
    }
  }

  searchIconEventListener() {
    this.searchIcon.addEventListener('click', () => {
      this.toggleSearchBar();
    });
  }

  scrollHandler = () => {
    this.currentScrollPos = window.pageYOffset;

    // Check if the user has scrolled far enough for the header to not be visible...
    if (
      this.currentScrollPos >
      this.marquee.offsetHeight + this.shopifyHeader.offsetHeight
    ) {
      // If so, check whether the header should be shown.
      if (this.shouldShowHeader()) {
        this.showHeader();
      } else {
        // Otherwise, hide the header.
        setTimeout(() => {
          this.hideHeader();
        }, 250);
      }
    } else {
      // Otherwise, the header is visible.
      dispatchEvent(EVENT.HEADER.VISIBLE, document);
    }

    if (this.shouldShowSearchIcon()) {
      this.showSearchIcon();
    }

    this.prevScrollpos = this.currentScrollPos;
  };
}

window.onscroll = () => {
  const svg1 = document.querySelector('.svg1');
  const svg2 = document.querySelector('.svg2');
  const top = window.scrollY;

  if (top > 100) {
    svg2.classList.add('active');
    svg1.classList.add('slide');
  } else {
    svg1.classList.remove('slide');
    setTimeout(() => {
      svg2.classList.remove('active');
    }, 600);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new StickyHeader(document.querySelector('#shopify-section-header'));
});
